import React from "react";

import { Props } from "./types";
import styles from "./styles.scss";

function InfoTagsBox({ tags }: Props) {
  // @ts-ignore
  const tagsName: string[] = tags.map((tag) => (tag.name ? tag.name : tag));
  return (
    <div className={styles.infoTagsBox}>
      {tagsName.map((tag) => (
        <div className={styles.name}>
          <p>{tag}</p>
        </div>
      ))}
    </div>
  );
}

export { InfoTagsBox };
